import { render } from "./ClaimFollowups.vue?vue&type=template&id=7e377560&scoped=true"
import script from "./ClaimFollowups.vue?vue&type=script&lang=js"
export * from "./ClaimFollowups.vue?vue&type=script&lang=js"

import "./ClaimFollowups.vue?vue&type=style&index=0&id=7e377560&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e377560"]])

export default __exports__